module.exports = __webpack_public_path__ + "img/charging station.072c06e9.png";